import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { FiMoreHorizontal } from "react-icons/fi";
import { Dropdown } from 'react-bootstrap';
import PlanViewEditModal from 'components/PlanViews/PlanViewEditModal';
import { showModal, hideModal } from "actions/modalActions";
import * as plansActions from 'actions/plansActions';
import { planViewsService } from "services";
import { errorFormating } from "utils/utils";
import {
	getScopeDisplayLabel,
	translatePlanViewDetailLabel,
	translatePlanViewName,
} from "./planViewColumns";

class PlanViewsList extends Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.closeModal = this.closeModal.bind(this);
		this.openEditPlanViewModal = this.openEditPlanViewModal.bind(this);
		this.openDeletePlanViewModal = this.openDeletePlanViewModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	closeModal() {
		this.props.hideModal()
	}

	openEditPlanViewModal(planView) {
		this.props.showModal({
			open: true,
			title: i18next.t('planViews.editView'),
			style: { width: '600px' },
			content: <PlanViewEditModal planView={planView} handleClose={this.closeModal} />,
			closeModal: this.closeModal
		}, 'edit')
	}

	openDeletePlanViewModal(idPlanview) {
		this.props.showModal({
			open: true,
			title: i18next.t('planViews.deleteView'),
			style: { width: '400px' },
			message: i18next.t('planViews.deleteConfirm'),
			deleteAction: () => this.confirmDelete(idPlanview),
			closeModal: this.closeModal
		}, 'delete')
	}

	openAlertModal(message) {
		this.props.showModal({
			open: true,
			title: i18next.t('planViews.errorDeleting'),
			style: { width: '400px' },
			message: message,
			closeModal: this.closeModal
		}, 'alert')
	}

	confirmDelete = async (idPlanview) => {
		const response = await planViewsService.remove(idPlanview);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		}
		else {
			this.props.getPlanViews();
			this.closeModal();
		}
	}


	getEmptyRow = () => {
		return (
			<p>{i18next.t('common.noResults')}</p>
		);
	}

	getViewDetails = (view_details) => view_details.map((item, index) => {
		const label = translatePlanViewDetailLabel(item);
		const scope = item.scope ? getScopeDisplayLabel(item.scope) : null;

		return (
			<li key={index} aria-label={label} title={label}>
				{label}{scope ? ` (${scope})` : ""}
			</li>
		)
	});

	getRows = () => this.props.plan_views.map((planView) => {
		//console.log(planView);
		return (
			<div className="col-sm-6 col-lg-4 col-xl-3" key={planView.id}>

				<article className="card" key={planView.id}>
					<div className="card-top">
						<h2 className="card-title">{translatePlanViewName(planView)}</h2>
					</div>
					<div className="card-content">
						<div className="form-group no-form">
							<label>{i18next.t('planViews.labelColumns')}</label>
							<ul className="list-columns">
								{this.getViewDetails(planView.details)}
							</ul>
						</div>
					</div>

					<div className="card-actions bottom-right">
						<Dropdown>
							<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item as="button" onClick={() => this.openEditPlanViewModal(planView)}>{i18next.t('common.edit')}</Dropdown.Item>
								{
									!planView.system && (<Dropdown.Item as="button" onClick={() => this.openDeletePlanViewModal(planView.id)}>{i18next.t('common.delete')}</Dropdown.Item>)
								}
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</article>

			</div>
		)
	});

	render() {
		return (
			<>
				{this.props.plan_views.length === 0 ?
					this.getEmptyRow()
					:
					<div className="row list-plan-views">
						{this.getRows()}
					</div>
				}
			</>
		)
	}
}


const mapStateToProps = (reducers) => {
	return reducers.plansReducer;
};

const mapDispatchToProps = dispatch => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }))
	},
	getPlanViews: (q) => dispatch(plansActions.getPlanViews(q)),
})


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PlanViewsList))